function quadOut(t) {
  return -t * (t - 2.0);
}
module.exports = quadOut;